export default "__VITE_ASSET__ByzDWWjR__"